import styles from '@/styles/goodsAIRecommend.module.scss'
import Image from 'next/image'
import getConfig from 'next/config'
import useCartActions from '@/utils/addTocartAction'
import { useState } from 'react'
import { matomoSetCustomDimension } from '@/utils/matomoEvent';

const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

interface GoodsAIRecommendProps {
  productID: string | number
  name: string
  url: string
  imgUrl: string
  price: number
  normalPrice: number
  aiRecommendation: string
  reason_summary?: string
  highlight?: boolean
}

export default function GoodsAIRecommend(props: GoodsAIRecommendProps) {
  const { addToCart } = useCartActions()
  const [btnLoading, setBtnLoading] = useState(false)
  const [addToCartSuccess, setAddToCartSuccess] = useState(false)

  const addToCartCallBack = () => {
    setBtnLoading(false)
    // message.success('Item added to your cart!')
    setAddToCartSuccess(true)

    // matomo埋点，推荐商品的加购， addcart记录 json, sku+qty
    matomoSetCustomDimension(44, JSON.stringify({ productID: props.productID, qty: 1 }))
  }

  const handleAddToCart = (event: React.MouseEvent) => {
    event.stopPropagation() // 阻止事件冒泡，避免触发外层点击跳转
    setBtnLoading(true)
    addToCart(event, { productID: props.productID, qty: 1 }, addToCartCallBack)
  }

  const handleCardClick = () => {
    window.open(props.url, '_blank', 'noopener,noreferrer')

    // matomo埋点，点击推荐的商品   记录商品 pid
    matomoSetCustomDimension(45, props.productID)
  }

  const handleViewCart = (event: React.MouseEvent) => {
    event.stopPropagation() // 阻止事件冒泡，避免触发外层点击跳转
    window.open('/view-cart', '_blank', 'noopener,noreferrer')
  }

  return (
    <div 
      className={styles['goods-ai-recommend']}
      onClick={handleCardClick}
      style={{ cursor: 'pointer' }}
    >
      <div className={`${styles['product-card']} ${props.highlight ? styles['highlight'] : ''}`}>
        <div className={styles['product-main']}>
          <div className={styles['product-image-wrapper']}>
            <Image
              className={styles['product-image']}
              src={props.imgUrl}
              alt={props.name}
              width={120}
              height={120}
            />
          </div>
          
          <div className={styles['product-info']}>
            <div className={styles['product-title']}>
              {props.name}
            </div>
            
            <div className={styles['price-section']}>
              <div className={styles['price-wrapper']}>
                <div className={styles['current-price']}>${props.price}</div>
                {props.normalPrice && props.normalPrice > props.price && (
                  <div className={styles['original-price']}>
                    ${props.normalPrice}
                  </div>
                )}
              </div>
              {btnLoading ? (
                <Image
                  src={`${imageDomain}/ai-chat/load.gif`}
                  alt="loading"
                  width={26}
                  height={26}
                  className={styles['cart-icon']}
                />
              ) : addToCartSuccess ? (
                <Image
                  src={`${imageDomain}/ai-chat/shopcart-ok-2.svg`}
                  alt="added to cart"
                  onClick={handleViewCart}
                  width={26}
                  height={26}
                  style={{ cursor: 'pointer' }}
                  className={styles['cart-icon']}
                />
              ) : (
                <Image
                  src={`${imageDomain}/ai-chat/shopcart.svg`}
                  alt="add to cart"
                  onClick={handleAddToCart}
                  width={26}
                  height={26}
                  style={{ cursor: 'pointer' }}
                  className={styles['cart-icon']}
                />
              )}
            </div>
          </div>
        </div>
        
        {props.reason_summary && props.aiRecommendation && (
          <div className={styles['ai-recommendation-section']}>
            <div className={styles['ai-header']}>
              <Image
                src={`${imageDomain}/ai-chat/ai-product-reason-icon.svg`}
                alt="AI"
                width={27}
                height={27}
                className={styles['ai-icon']}
              />
              <span className={styles['ai-title']}>
                AI | {props.reason_summary}
              </span>
            </div>
            <div className={styles['ai-content']}>
              {props.aiRecommendation}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

